import React, { useState, useEffect } from "react";

const styles = {
  loaderContainer: {
    width: "350px",
    height: "350px",
    borderRadius: "50%",
    //background: "linear-gradient(165deg, rgba(255,255,255,1) 0%, rgb(220, 220, 220) 40%, rgb(170, 170, 170) 98%, rgb(10, 10, 10) 100%)",
    position: "relative",
  },
  loader: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    borderBottom: "0 solid rgba(255, 255, 255, 0.02)",
    boxShadow: `
      0 -10px 20px 20px rgba(255, 255, 255, 0.25) inset,
      0 -5px 15px 10px rgba(255, 255, 255, 0.31) inset,
      0 -2px 5px rgba(255, 255, 255, 0.5) inset,
      0 -3px 2px rgba(255, 255, 255, 0.73) inset,
      0 2px 0px rgba(255, 255, 255, 1),
      0 2px 3px rgba(255, 255, 255, 1),
      0 5px 5px rgba(255, 255, 255, 0.56),
      0 10px 15px rgba(255, 255, 255, 0.38),
      0 10px 20px 20px rgba(255, 255, 255, 0.25)
    `,
    filter: "blur(3px)",
    animation: "rotate 2s linear infinite",
  },
};

const BounceLoader = ({ isLoading, delay = 100 }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [loadingFinished, setLoadingFinished] = useState(false);

  useEffect(() => {
    let delayTimer;

    if (isLoading) {
      setLoadingFinished(false);
      delayTimer = setTimeout(() => setShowLoader(true), delay);
    } else {
      setLoadingFinished(true);
    }

    return () => clearTimeout(delayTimer);
  }, [isLoading, delay]);

  if (!showLoader || loadingFinished) return null;

  return (
    <div style={styles.loaderContainer}>
      <div style={styles.loader}></div>
      <style>{`@keyframes rotate { 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default BounceLoader;
